import LeftCloudIcon from "@/../public/dashboard/left_cloud.svg?react";
import RightCloudIcon from "@/../public/dashboard/right_cloud.svg?react";
import LeftHandIcon from "@/../public/dashboard/left_hand.svg?react";
import { useEffect, useRef } from "react";
import useRecommendedSpreadStore from "@/entities/analysis-ai/model/useRecommendedSpreadStore";

const CloudsHands = () => {
  const ref = useRef<HTMLDivElement>(null);
  const leftHandIcon = useRef<SVGSVGElement>(null);
  const RightHandIcon = useRef<SVGSVGElement>(null);
  const recommendedSpread = useRecommendedSpreadStore(
    (state) => state.recommendedSpread
  );

  useEffect(() => {
    setTimeout(() => {
      if (ref.current && leftHandIcon.current && RightHandIcon.current) {
        ref.current.style.opacity = "1";
        leftHandIcon.current.style.scale = "1 1";
        RightHandIcon.current.style.scale = "-1 1";
      }
    }, 1000);
  }, []);

  useEffect(() => {
    if (!leftHandIcon.current || !RightHandIcon.current) return;

    const hasRecommended =
      !!recommendedSpread && recommendedSpread.length > 0;

    if (hasRecommended) {
      leftHandIcon.current.style.opacity = "0";
      RightHandIcon.current.style.opacity = "0";
      leftHandIcon.current.style.bottom = "-200px";
      RightHandIcon.current.style.bottom = "-200px";
    } else {
      leftHandIcon.current.style.opacity = "1";
      RightHandIcon.current.style.opacity = "1";
      leftHandIcon.current.style.bottom = "0px";
      RightHandIcon.current.style.bottom = "0px";
    }
  }, [recommendedSpread]);
  return (
    <div
      ref={ref}
      className="clouds-hands-container pointer-events-none fixed top-0 left-0 z-20 h-full w-full origin-bottom opacity-0 mix-blend-soft-light transition-all duration-2000 ease-in-out max-[400px]:hidden"
    >
      <LeftHandIcon
        ref={leftHandIcon}
        className="leftHandIcon  scale-[75%_75%] origin-bottom  absolute left-1/2 translate-x-[-200%] bottom-0 transition-all duration-2000 ease-in-out"
      />
      <LeftHandIcon
        ref={RightHandIcon}
        className="rightHandIcon scale-[-75%_75%] origin-bottom absolute right-1/2 translate-x-[200%] bottom-0 transition-all duration-2000 ease-in-out"
      />
      <LeftCloudIcon className="absolute left-0 bottom-0" />
      <RightCloudIcon className="absolute right-0 bottom-0" />
    </div>
  );
};

export default CloudsHands;
